import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { map, mergeMap, tap } from 'rxjs/operators';
import { StorageConfig } from '~/app/config/storage.config';
import { AuthService } from '~/app/core/auth/services/authentication.service';
import { MessageService, TOASTTYPE } from '~/app/core/services/message.service';
import { LayoutService } from '~/app/core/services/store/layout.service';

const setRedirectInformation = (url: string): void => {
  localStorage.setItem(StorageConfig.REDIRECT, url);
};

const canActivateCheck = (): Observable<boolean> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const messageService = inject(MessageService);
  const layoutService = inject(LayoutService);
  const translate = inject(TranslateService);

  const errorHandler = () => {
    layoutService.toggleUserSidebar(true);
    router.navigate(['/']);
    setTimeout(() => {
      messageService.showToast(TOASTTYPE.ERROR, translate.instant('general.noPermissionForPage'));
    }, 500);
  };

  return authService.getToken().pipe(
    mergeMap((token) => {
      if (!token) return of(false);
      return authService.getTokenExpiration(token).pipe(
        map((authTokenExpiration) => {
          const now = Date.now() / 1000; // converts millis to secs
          return Boolean(token) && now <= authTokenExpiration;
        }),
      );
    }),
    tap((value) => {
      if (!value) {
        errorHandler();
      }
    }),
  );
};

export const authenticationGuard: CanActivateFn = (route, state) => {
  setRedirectInformation(state.url);
  return canActivateCheck();
};
